import React, { useEffect, useRef, useState } from 'react';
import { Banners } from '../services/website.services';
import { createSlider } from '../../../utils/commonfunction';
import Skeleton from 'react-loading-skeleton'
import { useTranslation } from 'react-i18next';



const WebsiteBanners = ({ id = "bannerSlider" }) => {

    const [bannerData, setBannerData] = useState([]);
    const [apiLoaded, setApiLoaded] = useState(false);
    const { t } = useTranslation()
    const BannerHomeSliderRef = useRef();


    useEffect(() => {
        Banners().then((response) => {
            setApiLoaded(true);
            setBannerData(response?.data?.list || []);
        }).catch((err) => {
            console.log("err", err);
        })
    }, []);

    useEffect(() => {
        if (BannerHomeSliderRef?.current) {
            createSlider(`#${id}`, {
                loop: true,
                margin: 20,
                nav: true,
                dots: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 2
                    },
                    1000: {
                        items: 3
                    }
                }
            });
        }
    }, [BannerHomeSliderRef, apiLoaded]);

    return (
        <>
            {apiLoaded ?
                bannerData.length ?
                    <section className="section-padding">
                        <div className="container">
                            <>
                                {bannerData ?
                                    <div className="offer-banner-slider owl-carousel owl-theme enable-nav-flex" id={id} ref={BannerHomeSliderRef}>
                                        {bannerData && bannerData.map((item, index) => (
                                            <div className="itme" key={index}>
                                                <figure>
                                                    <a
                                                        href={item.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="banner-link"
                                                        title={item?.link} 
                                                    >
                                                        <img alt={item?.title} src={item?.image} className="img-fluid banner-img" />
                                                    </a>
                                                </figure>
                                            </div>
                                        ))}
                                    </div>
                                    : null}
                            </>
                        </div>
                    </section>

                    : null

                :
                <section className="section-padding">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 ">
                            <Skeleton className='rounded-4' height={200} />
                        </div>
                        <div className="col-lg-3 col-md-4  d-none d-md-block">
                            <Skeleton className='rounded-4' height={200} />
                        </div>
                        <div className="col-lg-3 col-md-4  d-none d-md-block">
                            <Skeleton className='rounded-4' height={200} />
                        </div>
                        <div className="col-lg-3 col-md-4  d-none d-lg-block">
                            <Skeleton className='rounded-4' height={200} />
                        </div>
                    </div>
                </section>
            }
        </>
    )
}

export default WebsiteBanners



